var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.809 3H10.1089C6.18277 3 3 6.18275 3 10.1089V316.809C3 320.735 6.18277 323.917 10.1089 323.917H316.809C320.735 323.917 323.917 320.735 323.917 316.809V10.1089C323.917 6.18275 320.735 3 316.809 3Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.029 163.395L163.48 6.84668L6.93241 163.395L163.48 319.943L320.029 163.395Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.609 88.3057H93.3057C90.5442 88.3057 88.3057 90.5442 88.3057 93.3057V233.609C88.3057 236.37 90.5442 238.609 93.3057 238.609H233.609C236.37 238.609 238.609 236.37 238.609 233.609V93.3057C238.609 90.5442 236.37 88.3057 233.609 88.3057Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.366 158.367L168.61 100.611C165.777 97.7779 161.184 97.7779 158.351 100.611L100.595 158.367C97.7616 161.2 97.7616 165.793 100.595 168.626L158.351 226.383C161.184 229.216 165.777 229.216 168.61 226.383L226.366 168.626C229.199 165.793 229.199 161.2 226.366 158.367Z",
    fill: "#CDD7D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwTeam);
export default __webpack_public_path__ + "static/media/dfw-Team.9f11cd96fce5a38e0f18a100bf2ab1f0.svg";
export { ForwardRef as ReactComponent };